// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3vA2G","header":"Messages_header__MHbCS"};